import styled from 'styled-components';
import Content from 'gatsby-theme-core/src/components/content';
import textStyle from './text-style';

export default styled(Content)`
  ${textStyle}
  p {
    font-size: 1rem;
    line-height: 150%;
    font-weight: 300;
    @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
      font-size: 1.444rem;
    }
  }
`;
